/* Gullye — design-group switcher: hovering a swatch previews that piece's name.
   The tap itself is a plain link, so this is enhancement only. Delegated and
   guarded: the snippet renders in both the mobile and desktop PDP sections. */
(function () {
  if (window.__gyDgInit) return;
  window.__gyDgInit = true;

  function nameEl(sw) {
    var wrap = sw.closest('[data-gy-designgroup]');
    return wrap ? wrap.querySelector('[data-gy-dg-name]') : null;
  }
  function show(sw) {
    var out = nameEl(sw);
    if (!out) return;
    if (!out.dataset.gyDgBase) out.dataset.gyDgBase = out.textContent;
    out.textContent = sw.getAttribute('aria-label') || out.dataset.gyDgBase;
  }
  function reset(sw) {
    var out = nameEl(sw);
    if (out && out.dataset.gyDgBase) out.textContent = out.dataset.gyDgBase;
  }
  function on(evt, fn) {
    document.addEventListener(evt, function (e) {
      var sw = e.target.closest && e.target.closest('.gy-dg__sw');
      if (sw) fn(sw);
    }, true);
  }
  on('mouseover', show);
  on('focusin', show);
  on('mouseout', reset);
  on('focusout', reset);
})();
